import { PaginationArgument } from "./paginationArgument";
import { SortingArgument } from "./sortingArgument";

export class GridArgument {

  pagination?: PaginationArgument;

  sorting?: SortingArgument;
}